// @ts-ignore
import HttpService from '@/shared/services/HttpService';
import {getIdFromIri} from "@/shared/utils";

class ContestService {
    private http = new HttpService();

    public async fetchUpcoming(userId: any, date: string, pageUrl: string) {
        try {
            const url = pageUrl ? pageUrl.substring(1) : `football/contests?entries.user=${userId}&status=1&pagination=true&itemsPerPage=5`;
            const response = await this.http.get(url);
            return this.formatContestListResponse(response, 'Your Contests', 'Upcoming contests');

        } catch (e) {
            return e;
        }
    }

    public async fetchLive(userId: any, date: string, pageUrl: string) {
        try {
            const url = pageUrl ? pageUrl.substring(1) : `football/contests?entries.user=${userId}&status=2&pagination=true&itemsPerPage=5`;
            const response = await this.http.get(url);
            return this.formatContestListResponse(response, 'Your Contests', 'Live contests');

        } catch (e) {
            return e;
        }
    }

    public async fetchHistory(userId: any, date: string, pageUrl: string) {
        try {
            const url = pageUrl ? pageUrl.substring(1) : `football/contests?entries.user=${userId}&status=3&pagination=true&itemsPerPage=5`;
            const response = await this.http.get(url);
            return this.formatContestListResponse(response, 'Your Contests', 'History contests');
        } catch (e) {
            return e;
        }
    }

    public async fetchContestDetails(id: string): Promise<any> {
        return await this.http.get('football/contests/' + id);
    }

    public async fetchContestParticipants(id: string): Promise<any> {
        const result =  await this.http.get(`ap/contests/${id}/games`);
        return result['hydra:member'].map((x: any) => ({username: x.user.username, id: x.user.ref}));
    }

    public async fetchContestPlayers(id: string, playerType: number, season: any, pageUrl?: any, search?: string): Promise<any> {
        let url = pageUrl ? pageUrl.substring(1) : `football/data/player_teams?season=${season}&position=${playerType}&itemsPerPage=20`;
        if (search) {
           url += '&player.name=' + search
        }
        const result = await this.http.get(url);
        return { players: result['hydra:member'].map((x: any) => (
                {
                    name: x.player.name || 'Nombre del jugador',
                    id: getIdFromIri(x.player['@id']),
                    team: x.team.name || 'Nombre del equipo',
                    spriteName: x.spriteName,
                    spritePosition: x.spritePosition,
                    position: x.position,
                    image: x.player.imageUrl,
                    price: x.player.moneyAmount / 100,
                    prettyPrice: '$' + x.player.moneyAmount / 100000000 + 'M',
                    rating: x.rating || 0
                }),
            ),
            totalItems: result['hydra:totalItems'],
            nextpage: result['hydra:view']['hydra:next']
        }

    }

    public async joinContest(id: string, payload: any): Promise<any> {
        try {
            return await this.http.put('game/' + id + '/join', payload);
        } catch (err) {
            throw err;
        }

    }

    public async fetchCompetitions() {
        try {
            const response = await this.http.get('football/data/competitions');
            return response['hydra:member'].map((competition: any) => ({
                id: competition.id,
                ['@id']: competition['@id'],
                name: competition.name,
                currentSeasonId: competition.currentSeason,
                currentSeason: competition.currentSeason
                // currentSeasonId: competition.currentSeason.split('/')[competition.currentSeason.split('/').length - 1]
            }));
        } catch (e) {
            return e;
        }
    }

    public async fetchCompetitionInfo(id: number) {
        try {
            return await this.http.get('ap/competitions/' + id);
        } catch (e) {
            return e;
        }
    }

    public async fetchRounds(filters: any) {
        const query = filters ? Object.keys(filters).map((key) => `${key}=${filters[key]}`).join('&') : '';
        try {
            const response = await this.http.get('football/data/rounds?' + query);
            return response['hydra:member'].map((round: any) => ({
                ['@id']: round['@id'],
                name: round.name
            }))
        } catch (e) {
            return e;
        }
    }

    public async fetchSeries(competitionId: string) {
        try {
            const response = await this.http.get('football/data/series?competition=' + competitionId);
            return response['hydra:member'];
        } catch (e) {
            return e;
        }
    }

    public async fetchCompetitionData(competitionId: string) {
        try {
            return this.http.get('football/data/competitions/' + competitionId);
        } catch (e) {
            return e;
        }
    }

    public async fetchSeasons(competitionId: string) {
        try {
            const response = await this.http.get('football/data/seasons?competition=' + competitionId);
            return response['hydra:member'];
        } catch (e) {
            return e;
        }
    }

    public async createContest(contest: any) {
        try {
            const data = { ...contest };
            data.maximumEntriesPerPlayer = parseInt(data.maximumEntriesPerPlayer, 10);
            data.moneyAmount = (data.moneyAmount * 100).toString();
            data.budgetAmount = (data.budgetAmount * 100000000).toString();
            data.maximumPlayers = parseInt(data.maximumPlayers, 10);
            data.private = eval(data.private);
            return await this.http.post('football/contests', data);
        } catch (e) {
            throw e;
        }
    }

    public async submitLineUp(data: any, entry: string) {
        try {
            return await this.http.put(`football/contests/entries/${entry}/lineup`, data);
        } catch (e) {
            throw e;
        }
    }

    private formatContestListResponse(response: any, description: string, title: string) {
        return {
                items: response['hydra:member'].map((item: any) => ({
                    totalWinnings: item.totalWinnings,
                    winners: item.numWinners,
                    spots: item.entries.length,
                    totalSpots: item.maximumPlayers,
                    entryFee: item.moneyAmount / 100,
                    id: item.id,
                    ['@id']: item['@id'],
                    title: item.title,
                    competitionName: item.competitionName || 'Liga española',
                    onlyWatch: true,
                })),
                description,
                title,
                error: false,
                loading: false,
                tag: 'begginer',
                total: response['hydra:totalItems'],
                nextpage: response['hydra:view']['hydra:next']
            };
    }
}

export default new ContestService();
